import React from 'react';
import { useParams } from 'react-router-dom';
import DashboardLayout from '../Common/Layouts/DashboardLayout';
import SeoMeta from '../../SEO/SeoMeta';

export default function UserProfilePage() {
  const { id } = useParams();

  return (
    <>
      <SeoMeta 
        title={`User Profile — Million2Trillion (M2T)`} 
        description={`View detailed profile information of verified market professionals on Million2Trillion.`}
        url={`https://million2trillion.com/dashboard/user/${id}`}
      />

      <DashboardLayout>
        <div className="p-6">
          <h2 className="text-2xl font-bold mb-4">👤 User Profile</h2>
          <p>This is a placeholder profile page for user ID: <strong>{id}</strong></p>
          {/* Later, you can fetch and show actual user data from DB or dummyUsers */}
        </div>
      </DashboardLayout>
    </>
  );
}
